import { Input, Modal, ModalBottomButtons } from '@bp/ui-components';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PimUserDataType } from '../Tables/PimUserTable';

type InviteModalProps = {
  pimProfile: PimUserDataType;
  isOpen: boolean;
  onClose: () => void;
  onInvite: (email: string) => Promise<void>;
};

export const InviteModal = ({ isOpen, onClose, onInvite, pimProfile }: InviteModalProps) => {
  const [email, setEmail] = useState<string>('');

  const { t } = useTranslation();

  useEffect(() => {
    setEmail(pimProfile.profileEmail ?? pimProfile.userEmail ?? '');
  }, [pimProfile.userEmail, pimProfile.profileEmail]);

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      title={t('users.inviteUser', { name: `${pimProfile.lastName}, ${pimProfile.firstName}` })}
    >
      <Input
        label={t('common.email')}
        type={'email'}
        value={email}
        onChange={(e) => {
          setEmail(e.target.value);
        }}
        name={'email'}
      />
      <ModalBottomButtons
        closeButton={{
          callback: onClose,
        }}
        submitButton={{
          callback: async () => {
            if (email) {
              await onInvite(email);
              onClose();
            }
          },
          disabled: !email,
        }}
      />
    </Modal>
  );
};
